




































































































































































































import {Vue, Component, Prop, Watch,} from 'vue-property-decorator';
import { Letter } from '@/store/models/Letter/Letter';
import { saveFile, converBase64toBlob, getPersianDate } from '@/util/utils';
import LetterAttachmentMobile from '@/components/MobileComponents/LetterDetailsMobile/LetterAttachmentMobile/LetterAttachmentMobile.vue';
import * as fileService from '@/store/Services/fileService';
import * as letterService from '@/store/Services/letterServices';
import Parts from '@/store/models/Letter/Parts';
import LetterTrailTreeMobile from './LetterTrailMobile/LetterTrailTreeMobile.vue';
import { LetterTrail } from '@/store/models/Letter/LetterTrail';
import * as $ from 'jquery';
import FinalizeLetterMobile from './FinalizeLetterMobile/FinalizeLetterMobile.vue';
import * as util from '@/util/utils.ts';
import { LetterSearchResult } from '../../../store/models/Letter/LetterSearchResult';
import * as enterpriseFormService from '@/store/Services/enterpriseFormService';
import store from '@/store';
import { EnterpriseForm } from '@/store/models/EnterpriseForm/EnterpriseForm';
import pdf from 'vue-pdf';
import DependencyGraphContainer from '@/components/Cartable/LetterDetails/DependencyGraph/DependencyGraphContainer.vue'


@Component({
    name:"LetterDetailsMobile",
    components:{LetterAttachmentMobile, LetterTrailTreeMobile, FinalizeLetterMobile,DependencyGraphContainer}
})
export default class LetterDetailsMobile extends Vue {
   
    isReceived = true;
    isLoading= false;
    testUrl= '';
    pdfSrc = {} as any;
    shallShowNextEnterpriseForms= false;
    @Prop() letter?: Letter;
    nextEnterpriseForms = [] as EnterpriseForm[];
    @Watch("letter")
    onLetterChanged(newVal: Letter, oldVal: Letter){
        // if(this.letter){
        //     alert(this.letter.id);
        //     alert(this.letter.letterPossessionId);
        // }
        this.shallShowNextEnterpriseForms= false;
        console.log(this.letter);
        this.setIsReceived();
        this.setPdfUrl();
        this.canFinalize = !newVal.isClosed;
        this.canReject = newVal.isClosed;
        this.nextEnterpriseForms = [];
        this.loadNextForms();
    }

    created(){
        this.setIsReceived();
        this.loadNextForms();
        if(this.letter){
            this.canFinalize = !this.letter.isClosed;
            this.canReject = this.letter.isClosed;
        }
        store.state.eventHub.$on('show-file-requested',this.onShowFileRequested);
    }

    onShowNextEnterpriseForms(){
        if(this.nextEnterpriseForms.length==1){
            this.loadNextForm(this.nextEnterpriseForms[0].id);
        }else{
            this.shallShowNextEnterpriseForms=true;
        }
    }
    
    close(){
        this.shallShowNextEnterpriseForms=false;
    }
    
    viewedFileName = "";
    async onShowFileRequested(fileId: string)
    {
        
                const file = await fileService.getFile(fileId);
                if(file.extension.toLowerCase().includes("pdf")){
                    //for pdf insert code here
                    this.noPdfExists = false;
                    this.pdfSrc = "data:application/pdf;base64," + file.content;
                    this.viewedFileName = file.extension;
                    this.hasHtmlMainFile = false;
                    this.pdfLoaded = true;
                    // const blob =  converBase64toBlob(file.content||"",'');
                    // const url = window.URL.createObjectURL(blob);
                    // this.testUrl= 'https://docs.google.com/gview?'+'url='+url.toString();
                    //  console.log(this.testUrl)

                }
                else{
                  
                    this.noPdfExists = true;
                    this.pdfSrc = "data:image/png;base64," + file.content;
                    this.viewedFileName = file.extension;
                    this.hasHtmlMainFile = false;
                }
                
            
    }
    returnToParentPage(){
        this.$emit('returnToParentPage')
    }

    get attachments(){
        
        const result: Parts[] = [];
        if(this.letter === undefined)return result;
        if(this.letter.parts === undefined || this.letter.parts === null)return result;
        for(let i = 1;i<this.letter.parts.length;i++){
            result.push(this.letter.parts[i]);
        }
        return result;
    }

    get letterTime(){
        
        if(!this.letter) return '';
        const date = new Date( this.letter.sendTime.substring(0,this.letter.sendTime.length -1));
        return (date).toLocaleTimeString();
    }
    setIsReceived(){
        this.isReceived = false;
        if(this.letter == undefined)return;
        if(this.letter.recievers === null)
            this.isReceived = true;
    }
    

    // progressBar(){
    //     let width = 1;
    //     const elem = document.getElementById("myBar");
    //     while (this.isLoading==true) {
    //         if (width <= 100) {
    //             if(elem==null) return '';
    //             width++;
    //             elem.style.width = width*20 + "%";
    //         }
    //     }
        
    // }
    // frame() {
    //     let i = 0;
    //     const id = setInterval(this.frame, 10);
    //     if (i == 0) {
    //         i = 1;
    //         setInterval(this.frame, 10);
    //     }
    //     if (this.width >= 100) {
    //         clearInterval(id);
    //         i = 0;
    //     } else {
    //         if(this.elem==null) return '';
    //         this.width++;
    //         this.elem.style.width = this.width + "%";
    //     }
    // }

    async downloadLetterPdf(){
       
        try {
            this.isLoading=true;
            if(this.letter === undefined)return;
            if(this.letter.parts === undefined || this.letter.parts === null)return;
            const file = await fileService.getFile(this.letter.parts[0].file.id);
            const blob =  converBase64toBlob(file.content||"",'');
            saveFile(blob,file.extension);
        } catch (error) {
            console.log(error)
        }finally{
            // this.progressBar();
            this.isLoading=false;
        }
    }
    pdfLoaded = false;
    noPdfExists = false;
    htmlSrc = "";
    numPages= 0;
    hasHtmlMainFile = false;
    async setPdfUrl(){
         if(this.letter === undefined)return;
         this.pdfLoaded = false;
         this.noPdfExists = false;
        if(this.letter.parts === undefined || this.letter.parts === null)return;
            const file = await fileService.getFile(this.letter.parts[0].file.id);
            if(this.letter.parts[0].file.extension.toLowerCase().includes('.html')){
                this.htmlSrc = util.b64DecodeUnicode(file.content);
                console.log(this.htmlSrc);
                this.hasHtmlMainFile = true;
            }
            else if(this.letter.parts[0].file.extension.toLowerCase().includes('.pdf')){
                // this.pdfSrc = "data:application/pdf;base64," + file.content;
                this.pdfSrc = `data:application/pdf;base64,` + file.content;
                this.pdfLoaded = true;
                this.hasHtmlMainFile = false;
            }else{
                this.noPdfExists = true;
                this.pdfSrc = "data:image/png;base64," + file.content;
                // this.pdfSrc = `data:application/pdf;base64,` + file.content;
                this.hasHtmlMainFile = false;
        }

        const blob =  converBase64toBlob(file.content||"",'');
        const url = window.URL.createObjectURL(blob);
        const pdfSrc = pdf.createLoadingTask(url);
        // console.log('pdfSrc', this.pdfSrc)
        pdfSrc.promise.then((pdf: any)=> {
            // console.log('pdf', pdf)
            this.numPages = pdf.numPages
        });

        // var loadingTask = pdf.createLoadingTask('https://cdn.mozilla.net/pdfjs/tracemonkey.pdf');
        //  loadingTask.promise.then((pdf: any)=> {
 
        //     this.numPages = pdf.numPages;
        // });
    }

    
    async mounted(){
         $('.letterDetails').sidebar({
            context: $('.mobileBottomLetterDetailsSegmant')
          }).sidebar('attach events','.sidebarLetterDetailsButton')
          .sidebar('setting', 'mobileTransition', 'overlay');

        $("#options-dropdown").dropdown({action: 'hide',silent: true});
        $("#return-dropdown").dropdown({action: 'hide',silent: true});
        $('#LetterAttachmentAccordion').accordion();
        $(".popup").popup();
        await this.setPdfUrl();
        // this.$router.push({name: "LetterDetailsMobile"});
    }
    
    replayReload(){
        $("#return-dropdown").dropdown();
    }

    updated(){
         $("#nextforms-dropdown").dropdown({action: 'hide',silent: true});
    }

    finalizeLetter(){
        if(this.letter === undefined || this.letter === null) return;
        this.$emit('finalize-letter',this.letter.id);
    }
    canFinalize = true;
    canReject = false;
    finalizing = false;
    async finalizeLetterFast(){
        if(!this.letter)return
        this.finalizing = true;
        this.canFinalize = false;
        const result =  await letterService.CloseLetterFast(this.letter.letterPossessionId);
        this.$emit('letter-closed-fast',this.letter.letterPossessionId);
        this.letter.isClosed = true;
        this.finalizing = false;
        this.canReject = true;
      
    }
    async restoreLetter(){
        if(!this.letter)return
        this.finalizing = true;
        this.canReject = false;
        const result =  await letterService.RejectClosedLetter(this.letter.letterPossessionId);
        this.$emit('closed-letter-rejected',this.letter.letterPossessionId);
        this.letter.isClosed = false;
        this.finalizing = false;
        this.canFinalize = true;
    }
    forwardLetter(){
        if(this.letter)
            this.$emit('forward-letter',this.letter.letterPossessionId);
    }

    get receiversStr()
    {
        if(!this.letter)return '';
        if(!this.letter.recievers) return '';
        let result = '';
        this.letter.recievers.forEach(x=>{
            if(result !== '') result = result + ' | ' + x.nameOnly;
            else result = x.nameOnly;
        });
        return result;
    }

    sendFastDependOn(mode: string){
        this.$emit('send-fast-dependon',mode);
    }

    async loadNextForms(){
        if(!this.letter)return;
        if(!this.letter.isEnterpriseForm) return;
        const ownerId =  store.state.ownerId;
        const letterId = this.letter.id;
        const forms = await enterpriseFormService.getNextForms(letterId,ownerId);
        this.nextEnterpriseForms = forms;
       
    }

    loadNextForm(formId: string){
        //const nextForm =  this.nextEnterpriseForms.find(form=>form.id === formId);
        if(!this.letter)return;
        const request  = {} as any;
        request.formId = formId;
        request.letterId = this.letter.id;
        request.ownerId = store.state.ownerId;
        request.possessionId = this.letter.letterPossessionId;
        this.$emit('next-form-selected',request);
    }

    fitImage(){
        console.log($(this.$refs.previewContainer).find('img'));
    }
    shallShowDependencyGraph = false;
    ShowDependencyGraph(){
        this.shallShowDependencyGraph = true;
    }
    closeDependencyGraph(){
        this.shallShowDependencyGraph = false;
    }
    
}
